'use strict';

const HTTPService = require('../services/http-service');
const { readCookie } = require('../services/tracking/blz-tracking-util');

window.OneSignal = window.OneSignal || [];

window.OneSignal.push(function () {
  window.OneSignal.on('notificationPermissionChange', handlePermissionChange);
});

function updateLead(pushId) {
  if (!pushId) return;

  const { platform, customerId } = blz.globals;
  const { version } = blz;
  const deviceToken = readCookie('userIdentity');

  const pushData = {
    customerId,
    deviceToken,
    platform: platform === 'mobile' ? 'm.site' : 'desktop',
    pushId,
    version
  };

  HTTPService.put('/api/customers/lead', pushData);
}

function handlePermissionChange(permissionChange) {
  const currentPermission = permissionChange.to;

  if (currentPermission === 'granted') {
    window.OneSignal.getUserId().then(updateLead);
  }
}
